import React, { useContext } from 'react';
import { Col, Flex, Progress, Row, theme as antTheme } from 'antd';

import AccountPlanContext from '@totem/components/accountPlan/AccountPlanContext';
import {
  bandLabel,
  money,
  shortDate,
  StatBox,
} from '@totem/components/accountPlan/utilities';

const KpiBand = () => {
  const { data } = useContext(AccountPlanContext);
  const { token } = antTheme.useToken();
  if (!data) {
    return null;
  }
  const { health, revenue, tickets, vulnerabilities } = data.summary;
  const bandStroke = {
    healthy: token.colorSuccess,
    watch: token.colorWarning,
    atRisk: token.colorError,
  }[health.band];
  const next = revenue.nextRenewal;
  const optimizeOpen = tickets.worklist.filter(
    (item) => item.kind === 'advisory' && item.category === 'Optimize',
  ).length;

  return (
    <Row gutter={[12, 12]}>
      <Col xs={12} md={8} xl={4}>
        <StatBox
          labelFirst
          label="Account Health"
          value={
            <Flex align="center" justify="space-between">
              {health.score}
              <Progress
                type="circle"
                size={48}
                strokeWidth={10}
                percent={health.score}
                format={() => ''}
                strokeColor={bandStroke}
              />
            </Flex>
          }
          meta={`Blended ops · commercial · relationship (${bandLabel(health.band)})`}
        />
      </Col>
      <Col xs={12} md={8} xl={4}>
        <StatBox
          labelFirst
          label="Active Contracts"
          value={revenue.activeContracts}
          meta={`~${money(revenue.annualRunRate)} run rate · ${revenue.activeLines} active lines`}
        />
      </Col>
      <Col xs={12} md={8} xl={4}>
        <StatBox
          labelFirst
          label="Contracted Backlog"
          value={money(revenue.contractedBacklog)}
          meta={`${revenue.backlogLines} pending lines${revenue.backlogThrough ? ` thru ${new Date(revenue.backlogThrough).getUTCFullYear()}` : ''}${
            revenue.pendingDatesValue > 0
              ? ` · +${money(revenue.pendingDatesValue)} pend. dates`
              : ''
          }`}
        />
      </Col>
      <Col xs={12} md={8} xl={4}>
        <StatBox
          labelFirst
          label="Open Tickets"
          value={tickets.open}
          meta={`${tickets.openIncidents} incidents · ${tickets.openProjects} projects${
            optimizeOpen > 0 ? ` (${optimizeOpen} Optimize)` : ''
          } · ${tickets.openRequests} requests`}
        />
      </Col>
      <Col xs={12} md={8} xl={4}>
        <StatBox
          labelFirst
          label="Confirmed CVEs"
          value={
            vulnerabilities.scanning
              ? vulnerabilities.confirmedOpen.toLocaleString()
              : '—'
          }
          meta={vulnerabilities.scanning ? 'open' : 'monitoring ramping'}
          alert={vulnerabilities.confirmedOpen >= 100}
        />
      </Col>
      <Col xs={12} md={8} xl={4}>
        <StatBox
          labelFirst
          label="Next Renewal"
          value={next ? shortDate(next.date) : '—'}
          meta={
            next
              ? `${money(next.annual)} · ${next.buildingName}`
              : 'No negotiable renewal in the next 30 months'
          }
        />
      </Col>
    </Row>
  );
};

export default KpiBand;
